import NextImage, {ImageProps} from 'next/image'

import {DPImage} from 'types/DPTypes'
import css from './image.module.scss'
import {fromModule} from 'util/styler/Styler'
import {getPathBasename} from 'util/path'

const styles = fromModule(css)

// https://nextjs.org/docs/api-reference/next/image#sizes

export const Image: React.FC<
	DPImage & ImageProps & {sizes: ImageProps['sizes']}
> = ({overlay_percentage, use_dark_colors, ...props}) => {
	if (!props?.src) return null

	let src = props.src
	if (src.startsWith('/sites/default')) {
		src = process.env.NEXT_PUBLIC_DRUPAL_URL + src
	}

	if (props.fill)
		return (
			<NextImage
				{...props}
				src={src}
				width={undefined}
				height={undefined}
				fetchPriority={props.priority ? 'high' : 'auto'}
				style={props.style || {objectFit: 'cover'}}
				className={styles.image()}
				alt={props.alt || getPathBasename(props.src)}
			/>
		)

	return (
		<NextImage
			{...props}
			src={src}
			className={styles.image()}
			alt={props?.alt || getPathBasename(props.src)}
		/>
	)
}
